import { useEffect } from "react";

/** Ekran sarlavhasi va kontent. */
export function Page({ title, sub, actions, children }) {
  useEffect(() => {
    document.title = title ? `${title} · Rasid` : "Rasid";
  }, [title]);
  return (
    <>
      <header className="topbar">
        <div>
          <h1>{title}</h1>
          {sub && <div className="sub">{sub}</div>}
        </div>
        <span className="sp" />
        <div className="row">{actions}</div>
      </header>
      <div className="content">{children}</div>
    </>
  );
}
